import React from 'react';
import { Outlet } from 'react-router-dom';

import { Header } from '../Header';
import { PreventBackButton } from '../functional';
import { usePageTitle } from 'src/hooks/usePageTitle';

export function ConfirmBookingBookingLayout({ children }: React.PropsWithChildren) {
    usePageTitle();

    return (
        <div className="pb-[env(safe-area-inset-bottom, 0)] flex min-h-dvh flex-col bg-gray-50">
            <Header hideCloseButton progressBar />
            <div className="relative">
                <main className="mx-auto flex max-w-lg flex-1 flex-col px-5 pb-4 pt-12 lg:pb-12">
                    <Outlet />
                    {children}
                </main>
            </div>
            <PreventBackButton />
        </div>
    );
}
